import { render, staticRenderFns } from "./assetInvoice.vue?vue&type=template&id=6f68bc26&scoped=true"
import script from "./assetInvoice.vue?vue&type=script&lang=js"
export * from "./assetInvoice.vue?vue&type=script&lang=js"
import style0 from "./assetInvoice.vue?vue&type=style&index=0&id=6f68bc26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f68bc26",
  null
  
)

export default component.exports